import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';

const BackdropModalSignature = ({ open, handleClose, children, modalTitle, hasCloseButtonBelow = true, size = "md" }) => {
    return (
        <Dialog
            fullScreen // <-- This makes the dialog full screen
            fullWidth={true}
            maxWidth={size}
            open={open}
        >
            <div className='d-flex justify-content-end'>
                <div className='position-absolute'>
                    <button type="button" className='btn btn-sm ms-4 border-0' onClick={handleClose}>
                        <i className="bx bx-x fs-2"></i>
                    </button>
                </div>
            </div>
            <DialogTitle className='pb-0 fw-bold'>{modalTitle}</DialogTitle>
            <DialogContent  sx={{ paddingBottom: 0, overflow:'hidden' }}>
                <DialogContentText></DialogContentText>
                <Box
                    noValidate
                    component="form"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: 'auto',
                    }}
                >
                    <FormControl sx={{ mt: 2, minWidth: 100 }}>
                        {children}
                    </FormControl>
                </Box>
            </DialogContent>
            {hasCloseButtonBelow && (
                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                </DialogActions>
            )}
        </Dialog>
    );
};

export default BackdropModalSignature;
